import { render } from "./AudioUploader.vue?vue&type=template&id=fdd491c6&scoped=true"
import script from "./AudioUploader.vue?vue&type=script&lang=js"
export * from "./AudioUploader.vue?vue&type=script&lang=js"

import "./AudioUploader.vue?vue&type=style&index=0&id=fdd491c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd491c6"]])

export default __exports__